;
import { Component, OnInit,Inject,ViewChild,AfterViewInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators,UntypedFormBuilder } from '@angular/forms';
import { MatDialogRef,MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SharedService } from 'app/modules/common/services/shared-service';
import { CompanySideBarTreeViewService } from '../../services/company-side-bar-tree-view.service';
import { CompanyViewListComponent } from '../company-view-list.component';
import { PageLoaderService } from 'app/modules/common/services/page-loader.service';
import { CompanyManagementViewService } from '../../services/company-management-view.service';


@Component({
    selector: 'app-create-company',
    templateUrl: './create-company.component.html',
    styleUrls: ['./create-company.component.scss'],
    standalone: false
})
export class CreateCompanyComponent implements OnInit {
  createdCompanyId;
  save =1;
  close=0;
  saveButtontext:string="Guardar"
  @ViewChild(CompanyViewListComponent) companyViewList: CompanyViewListComponent;
  public addSubCompanyForm: UntypedFormGroup;
  constructor(
    public _dialogRef: MatDialogRef<CreateCompanyComponent>,
    private _formBuilder: UntypedFormBuilder,
    private _companySideBarTreeViewService: CompanySideBarTreeViewService,
    private _sharedService: SharedService,
    private _pageLoaderService: PageLoaderService,
    private _companyManagementViewService : CompanyManagementViewService,
    @Inject(MAT_DIALOG_DATA) public data: any

    ) { }

  ngOnInit(): void {
    this.addSubCompanyForm =new UntypedFormGroup( {
      id: new UntypedFormControl(0),
      padreId: new UntypedFormControl(0),
      companyName: new UntypedFormControl('',Validators.required ),
    } );
    this._companySideBarTreeViewService.createdCompanyName.subscribe(message=> this.createdCompanyId = message)
    
  }
  
  addSubCompany(){
    this.addSubCompanyForm.patchValue({
      padreId:this.data.padreId
    });
    this.addSubCompanyForm.markAllAsTouched();
    this.addSubCompanyForm.updateValueAndValidity();
    if (this.addSubCompanyForm.valid) 
    {
      if(this.addSubCompanyForm.get('id').value==0)
      {
        this.addSubCompanyData();
      }  
    }
  }

  private addSubCompanyData() {
    this._pageLoaderService.ShowPageLoader();
    this.saveButtontext="Guardar"
    this._companySideBarTreeViewService.CreateSubCompany(this.addSubCompanyForm.value.padreId,this.addSubCompanyForm.value.companyName.toUpperCase(),)
      .subscribe(res => {
        this._companySideBarTreeViewService.changecreatedCompanyName(res.result)
        this._companySideBarTreeViewService.changeCompanyEmpresaId(res.result)
        if (res.result >0 ) {
          this._companySideBarTreeViewService.changeCompanyEmpresaName(this.addSubCompanyForm.value.companyName)
          this._companyManagementViewService.clickedNewCompany$.next({id:res.result,name:this.addSubCompanyForm.value.companyName,padreId:this.addSubCompanyForm.value.padreId});
          this._companySideBarTreeViewService.sendClickUpdateEvent();
          //this._sharedService.ShowSnackBar('Sub empresa saved', 'Okay', 2000);
          this._pageLoaderService.HidePageLoader();
          this.cancel(this.save);
        } else {
          //this._sharedService.ShowSnackBar('Error saving sub empresa', 'Okay', 2000);
          this.cancel(this.save);
          this._pageLoaderService.HidePageLoader();
        }
      }, err => {
        this.cancel(this.save);
        console.log(err)
        this._pageLoaderService.HidePageLoader();
        this._sharedService.ShowSnackBar('Api request failed', 'Okay', 2000);      
      });
  }
  cancel(operation) {
    this._dialogRef.close(operation);
  }

}
